import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Gamepad2 } from 'lucide-react';

export default function ArtikelEidSpieleQuiz() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Eid Spiele und Quiz für Kinder</h1>
          <p className="text-lg text-white/80 leading-relaxed">Spielerisch lernen und feiern – die besten Spiele für den Eid-Tag.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Eid ist ein Tag der Freude – und was macht Kindern mehr Freude als Spielen? Hier findest du Spiele und Quizfragen, die den Eid-Tag unvergesslich machen und gleichzeitig islamisches Wissen vermitteln.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Gamepad2 className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Eid-Quiz: 20 Fragen</h2>
            </div>
            <p className="text-[#4B5563] mb-4">Perfekt für den Eid-Tag – drucke die Fragen aus oder lies sie vor!</p>
            
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <p className="font-medium text-[#2C332E] mb-3">Leichte Fragen (für jüngere Kinder):</p>
                <ol className="text-sm text-[#4B5563] space-y-2">
                  <li>1. Wie heißt unser heiliges Buch? <span className="text-[#4A5D4F]">(Quran)</span></li>
                  <li>2. In welchem Monat fasten Muslime? <span className="text-[#4A5D4F]">(Ramadan)</span></li>
                  <li>3. Was sagen wir zu Eid? <span className="text-[#4A5D4F]">(Eid Mubarak)</span></li>
                  <li>4. Wie viele tägliche Gebete gibt es? <span className="text-[#4A5D4F]">(5)</span></li>
                  <li>5. Womit bricht man traditionell das Fasten? <span className="text-[#4A5D4F]">(Datteln)</span></li>
                </ol>
              </div>
              
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <p className="font-medium text-[#2C332E] mb-3">Mittlere Fragen:</p>
                <ol className="text-sm text-[#4B5563] space-y-2" start="6">
                  <li>6. Wie heißt das Gebet am Morgen? <span className="text-[#4A5D4F]">(Fajr)</span></li>
                  <li>7. Welches Tier opfern viele Familien zu Eid ul Adha? <span className="text-[#4A5D4F]">(Schaf/Ziege/Rind)</span></li>
                  <li>8. Was bedeutet "Islam"? <span className="text-[#4A5D4F]">(Hingabe/Frieden)</span></li>
                  <li>9. Wie viele Monate hat das islamische Jahr? <span className="text-[#4A5D4F]">(12)</span></li>
                  <li>10. In welche Stadt pilgern Muslime? <span className="text-[#4A5D4F]">(Mekka)</span></li>
                </ol>
              </div>
              
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <p className="font-medium text-[#2C332E] mb-3">Schwierigere Fragen:</p>
                <ol className="text-sm text-[#4B5563] space-y-2" start="11">
                  <li>11. Wer war der erste Prophet? <span className="text-[#4A5D4F]">(Adam)</span></li>
                  <li>12. Was ist die Kaaba? <span className="text-[#4A5D4F]">(Das Haus Gottes in Mekka)</span></li>
                  <li>13. Was ist Zakat? <span className="text-[#4A5D4F]">(Armensteuer/Pflichtabgabe)</span></li>
                  <li>14. Wie viele Suren hat der Quran? <span className="text-[#4A5D4F]">(114)</span></li>
                  <li>15. Welcher Prophet baute die Arche? <span className="text-[#4A5D4F]">(Nuh/Noah)</span></li>
                </ol>
              </div>
              
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <p className="font-medium text-[#2C332E] mb-3">Experten-Fragen:</p>
                <ol className="text-sm text-[#4B5563] space-y-2" start="16">
                  <li>16. In welcher Stadt wurde der Prophet Muhammad ﷺ geboren? <span className="text-[#4A5D4F]">(Mekka)</span></li>
                  <li>17. Was ist Lailat al-Qadr? <span className="text-[#4A5D4F]">(Nacht der Bestimmung)</span></li>
                  <li>18. Wie heißt das Iftar-Gebet? <span className="text-[#4A5D4F]">(Dua des Fastenbrechens)</span></li>
                  <li>19. Was sind die 5 Säulen des Islam? <span className="text-[#4A5D4F]">(Shahada, Gebet, Zakat, Fasten, Hadsch)</span></li>
                  <li>20. Welcher Prophet sprach als Baby? <span className="text-[#4A5D4F]">(Isa/Jesus)</span></li>
                </ol>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Gruppenspiele für Eid</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🎯 Islamisches Tabu</h4>
                <p className="text-sm text-[#4B5563]">Ein Kind erklärt einen islamischen Begriff ohne bestimmte Wörter zu benutzen. Die anderen raten.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🏃 Moschee-Rennen</h4>
                <p className="text-sm text-[#4B5563]">Staffellauf, bei dem Kinder einen "Gebetsteppich" ausrollen, "beten" und zurücklaufen müssen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🎵 Eid-Musik-Stopp</h4>
                <p className="text-sm text-[#4B5563]">Wie "Stopptanz" – wenn die Musik (Nasheeds) stoppt, müssen alle eine Eid-Pose einnehmen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🔍 Eid-Schatzsuche</h4>
                <p className="text-sm text-[#4B5563]">Verstecke kleine Geschenke im Haus/Garten mit Hinweisen zu islamischen Themen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🎨 Eid-Pictionary</h4>
                <p className="text-sm text-[#4B5563]">Ein Kind malt islamische Begriffe (Moschee, Mond, Dattel, Gebetsteppich), die anderen raten.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Brettspiele & Kartenspiele</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">SIRA Quiz-Karten</h4>
                <p className="text-sm text-[#4B5563]">52 Quizkarten über das Leben des Propheten Muhammad ﷺ. Perfekt für Familienspieleabende.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">5 Pillars (Brettspiel)</h4>
                <p className="text-sm text-[#4B5563]">Strategiespiel rund um die 5 Säulen des Islam. Lehrreich und unterhaltsam.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Islamisches Memory</h4>
                <p className="text-sm text-[#4B5563]">Paare finden: Moschee zu Moschee, Mond zu Mond. Kann auch selbst gebastelt werden!</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Preise & Belohnungen</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <p className="text-[#4B5563] mb-3">Kleine Preise motivieren zusätzlich:</p>
              <ul className="text-[#4B5563] space-y-2">
                <li>• Halal-Süßigkeiten</li>
                <li>• Sticker</li>
                <li>• Kleine Spielzeuge</li>
                <li>• Eidi (Geld)</li>
                <li>• Extra Bildschirmzeit</li>
                <li>• Urkunde "Eid-Quiz-Champion"</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Spiele machen Eid für Kinder unvergesslich und vermitteln gleichzeitig Wissen über den Islam. Ob Quiz, Schatzsuche oder Brettspiel – gemeinsames Spielen stärkt die Familie und schafft schöne Erinnerungen.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/ramadan-aktivitaeten-kinder" className="text-[#4A5D4F] hover:underline">→ Ramadan Aktivitäten für Kinder</Link></li>
              <li><Link to="/ratgeber/25-geschenke-kinder" className="text-[#4A5D4F] hover:underline">→ 25 beste Eid Geschenke für Kinder</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Kinderprodukte entdecken</h3>
            <Link to="/geschenke/kinder" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
